import { useEffect, useState } from "react";
import { MonitorFaturamentoService } from "../../../../services";
import { responseErros } from "../../../../utils";
import MonitorFatCard from "./monitor-fat-card.view";
import MonitorFatRankingBarra from "./monitor-fat-ranking-barra.view";
import { Box, Divider, Typography } from "../../../../components";

const monitorFaturamentoService = new MonitorFaturamentoService();

function MonitorFatMeioPagamento({ filtrosBody }) {
  const [loading, setLoading] = useState(false);
  const [produtos, setProdutos] = useState([]);
  const [servicos, setServicos] = useState([]);

  useEffect(() => {
    buscarMeioPagamento();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtrosBody]);

  async function buscarMeioPagamento() {
    setLoading(true);
    const result = await monitorFaturamentoService.faturamentoMeioPagamento(
      filtrosBody,
    );
    if (!result.isAxiosError) {
      setProdutos(result.data?.produtos || []);
      setServicos(result.data?.servicos || []);
    } else {
      responseErros(result);
    }
    setLoading(false);
  }

  const itens = produtos.map((p) => ({
    key: p.meioPagamento,
    label: p.meioPagamento,
    valor: p.valor,
  }));

  const itensServicos = servicos.map((s) => ({
    key: s.meioPagamento,
    label: s.meioPagamento,
    valor: s.valor,
  }));

  return (
    <MonitorFatCard
      titulo="Faturamento por Meio de Pagamento"
      icone="ph-credit-card"
      loading={loading}
    >
      <Box display="flex" flexDirection="column" gap={1} className="mb-4">
        <Typography variant="h6" gutterBottom>
          Vendas
        </Typography>
        <Divider />
        <MonitorFatRankingBarra itens={itens} corBarra="#1976d2" />
      </Box>
      {itensServicos?.length > 0 && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Typography variant="h6" gutterBottom>
            Serviços
          </Typography>
          <Divider />
          <MonitorFatRankingBarra itens={itensServicos} corBarra="#d32f2f" />
        </Box>
      )}
    </MonitorFatCard>
  );
}

export default MonitorFatMeioPagamento;
